// =============================================================================
// ACT READING TEST BANK INDEX
// Combines all Reading test forms for Testing Mode
// =============================================================================

import { 
  formId as FORM_ID_25MC1,
  questions as questions_25MC1,
  scoringTable as SCORING_TABLE_25MC1,
  passages as PASSAGES_25MC1,
  categories as CATEGORIES_25MC1,
  totalQuestions as TOTAL_25MC1,
  scoredQuestions as SCORED_25MC1,
  fieldTestPositions as FIELD_TEST_25MC1,
  timeLimit as TIME_25MC1
} from './testBank-reading-25MC1.js';

import { 
  formId as FORM_ID_J08,
  questions as questions_J08,
  scoringTable as SCORING_TABLE_J08,
  passages as PASSAGES_J08,
  categories as CATEGORIES_J08,
  totalQuestions as TOTAL_J08,
  scoredQuestions as SCORED_J08,
  fieldTestPositions as FIELD_TEST_J08,
  timeLimit as TIME_J08
} from './testBank-reading-J08.js';

// -----------------------------------------------------------------------------
// SUBJECT METADATA
// -----------------------------------------------------------------------------
export const subjectInfo = {
  id: 'reading',
  name: 'Reading',
  icon: '📖',
  color: 'purple',
  totalTime: 40,
  description: 'Comprehension and analysis'
};

// -----------------------------------------------------------------------------
// CATEGORY DEFINITIONS
// -----------------------------------------------------------------------------
export const categoryDefinitions = {
  KID: { name: 'Key Ideas & Details', short: 'KID', description: 'Central ideas, summarizing, inferences, relationships' },
  CS: { name: 'Craft & Structure', short: 'CS', description: 'Word meaning, author\'s purpose, text structure' },
  IKI: { name: 'Integration of Knowledge & Ideas', short: 'IKI', description: 'Claims, evidence, multiple texts' }
};

// -----------------------------------------------------------------------------
// ALL TEST FORMS
// -----------------------------------------------------------------------------
export const testFormsData = {
  '25MC1': {
    metadata: {
      formId: '25MC1',
      subject: 'reading',
      source: 'Preparing for the ACT 2025-2026',
      testType: 'Practice Test',
      format: 'Enhanced',
      totalQuestions: TOTAL_25MC1,
      scoredQuestions: SCORED_25MC1,
      fieldTestPositions: FIELD_TEST_25MC1,
      timeMinutes: TIME_25MC1
    },
    questions: questions_25MC1,
    scoringTable: SCORING_TABLE_25MC1,
    passages: PASSAGES_25MC1,
    categories: CATEGORIES_25MC1
  },
  'J08': {
    metadata: {
      formId: 'J08',
      subject: 'reading',
      source: 'ACT October 2025 Release',
      testType: 'Released Test',
      format: 'Scored Only',
      totalQuestions: TOTAL_J08,
      scoredQuestions: SCORED_J08,
      fieldTestPositions: FIELD_TEST_J08,
      timeMinutes: TIME_J08
    },
    questions: questions_J08,
    scoringTable: SCORING_TABLE_J08,
    passages: PASSAGES_J08,
    categories: CATEGORIES_J08
  }
};

// -----------------------------------------------------------------------------
// TEST FORMS LIST (for dashboard display)
// -----------------------------------------------------------------------------
export const testFormsList = [
  {
    id: '25MC1',
    subject: 'reading',
    name: 'Reading Form 25MC1',
    format: 'Enhanced',
    source: 'Preparing for the ACT 2025-2026',
    questions: 36,
    scoredQuestions: 27,
    duration: 40,
    fieldTestPositions: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    available: true,
    hasRealQuestions: true
  },
  {
    id: 'J08',
    subject: 'reading',
    name: 'Reading Form J08',
    format: 'Scored Only',
    source: 'ACT October 2025 Release',
    questions: 27,
    scoredQuestions: 27,
    duration: 35,
    fieldTestPositions: [],
    available: true,
    hasRealQuestions: true
  }
];

// -----------------------------------------------------------------------------
// HELPER FUNCTIONS
// -----------------------------------------------------------------------------

/**
 * Get questions for a specific test form
 */
export function getTestQuestions(formId) {
  const form = testFormsData[formId];
  if (form) {
    return form.questions;
  }
  return [];
}

/**
 * Get only scored questions (excluding field test items)
 */
export function getScoredQuestions(formId) {
  const questions = getTestQuestions(formId);
  return questions.filter(q => q.isScored !== false);
}

/**
 * Calculate scaled score for a test form
 */
export function calculateTestScore(formId, rawScore) {
  const form = testFormsData[formId];
  if (form && form.scoringTable) {
    return form.scoringTable[rawScore] || 1;
  }
  // Default scoring for 27 scored questions
  return Math.round(1 + (rawScore / 27) * 35);
}

/**
 * Check if a form has real questions loaded
 */
export function hasRealQuestions(formId) {
  return !!testFormsData[formId]?.questions?.length;
}

/**
 * Get form metadata
 */
export function getFormMetadata(formId) {
  return testFormsData[formId]?.metadata || null;
}

/**
 * Get passages for a form
 */
export function getPassages(formId) {
  return testFormsData[formId]?.passages || [];
}

// -----------------------------------------------------------------------------
// STATS
// -----------------------------------------------------------------------------
export const testBankStats = {
  subject: 'reading',
  totalForms: testFormsList.length,
  formsWithQuestions: Object.keys(testFormsData).length,
  totalQuestions: Object.values(testFormsData).reduce((sum, form) => sum + (form.questions?.length || 0), 0)
};

console.log(`Reading Test Bank Loaded: ${testBankStats.formsWithQuestions} forms with ${testBankStats.totalQuestions} questions`);
